export type ReviewCtaButtonProps = {
  /** External "leave/write a review" URL — typically tenant.google_review_url. */
  href: string
  /** Button label, e.g. "Write a review" / "Leave a review on Google". */
  label: string
  /** 'md' (default) for header / inline CTAs; 'lg' for the prominent empty-state button. */
  size?: 'md' | 'lg'
}

/**
 * The canonical "leave/write a review" button, shared across the review
 * sections (wall_of_love header + empty state, reviews_summary CTA). Uses the
 * brand CTA token (`--color-cta` / auto-contrast `--color-cta-text`) rather
 * than `--brand-primary` + white text so pale-brand tenants keep a legible
 * label (the same contrast-floor trap as `surface_tone:inverse`).
 */
export function ReviewCtaButton({ href, label, size = 'md' }: ReviewCtaButtonProps) {
  const sizeClass = size === 'lg' ? 'px-7 py-3' : 'px-6 py-2.5'
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener nofollow"
      className={`inline-block bg-[var(--color-cta)] text-[var(--color-cta-text)] ${sizeClass} rounded-lg font-semibold hover:opacity-90 transition-opacity`}
    >
      {label}
    </a>
  )
}
